import { render, staticRenderFns } from "./dentalCariesReport.vue?vue&type=template&id=991a7152&scoped=true"
import script from "./dentalCariesReport.vue?vue&type=script&lang=js"
export * from "./dentalCariesReport.vue?vue&type=script&lang=js"
import style0 from "./dentalCariesReport.vue?vue&type=style&index=0&id=991a7152&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991a7152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('991a7152')) {
      api.createRecord('991a7152', component.options)
    } else {
      api.reload('991a7152', component.options)
    }
    module.hot.accept("./dentalCariesReport.vue?vue&type=template&id=991a7152&scoped=true", function () {
      api.rerender('991a7152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/dentalCariesReport/dentalCariesReport.vue"
export default component.exports